import React, { useEffect } from "react";
import "./Home_Blogs.css";
import Common_Title_2 from "../../common_components/common_title_2/Common_Title_2";
import Blue_Btn from "../../common_components/common_btn/Blue_Btn/Blue_Btn";
import Common_Blog_Card from "../../common_components/common_blog_card/Common_Blog_Card";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getblog } from "../../../features/blog/Slice";

const Home_Blogs = ({}) => {
  const navigate = useNavigate();

  const handleBlogClick = (blog) => {
    navigate(`/blog/${blog.id}`, { state: blog });
  };

  const blog = useSelector((state) => state.blog.blog);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getblog());
  }, [dispatch]);

  return (
    <section className="Home_Blogs">
      {blog?.data?.length > 0 && (
        <div className="container">
          <div className="top_div">
            <Common_Title_2 title={"Blogs"} />
            {blog?.data?.length > 3 && (
              <div className="view_btn_div">
                <Blue_Btn
                  btnText={"VIEW MORE BLOGS"}
                  onClick={() => {
                    navigate("/blogs");
                  }}
                />
              </div>
            )}
          </div>

          <div className="blog_cards_section">
            <div className="row">
              {blog?.data?.length > 0 &&
                blog?.data.slice(0, 3).map((blog) => (
                  <div
                    className="col-lg-4 col-md-6 col-sm-6 mb-4"
                    key={blog.id}
                  >
                    <Common_Blog_Card
                      blog={blog}
                      handleBlogClick={handleBlogClick}
                    />
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Home_Blogs;
